import React, { useEffect, useState } from "react";
import client from "../client/client";

import InputText from "../InputText/InputText";
import InputDate from "../InputDate/InputDate";
import InputFile from "../InputFile/InputFile";
import InputTextarea from "../InputTextarea/InputTextarea";
import InputRadio from "../InputRadio/InputRadio";
import InputSelect from "../InputSelect/InputSelect";

import PrewButton from "../PrewButton/PrewButton";
import NextButton from "../NextButton/NextButton";

const STATUS_CHOICES = [
  { value: 1, title: "Да" },
  { value: 2, title: "Нет" },
];

const FORMAT_CHOICES = [
  { value: "single", title: "Индивидуальный участник" },
  { value: "command", title: "Команда" },
];

const SPECIAL_CHOICES = [
  { value: "marketing", label: "Маркетинговое агентство" },
  { value: "advertising", label: "Рекламное агентство" },
  { value: "creative", label: "Креативное агентство" },
  { value: "design", label: "Дизайн-студия" },
  { value: "other", label: "Другое" },
];

function Step3(props) {
  const {
    setStep,
    participationType,
    setParticipationType,
    city,
    setCity,

    place,
    setPlace,
    haveIp,
    setHaveIp,
    inn,
    setInn,
    specialization,
    setSpecialization,
    expiration,
    setExpiration,
    portfolio,
    setPortfolio,
    format,
    setFormat,
    command,
    setCommand,

    position,
    setPosition,
    companyName,
    setCompanyName,
    legalName,
    setLegalName,
    special,
    setSpecial,
    otherSpecial,
    setOtherSpecial,
    ogrn,
    setOgrn,
    site,
    setSite,
    companyExpiration,
    setCompanyExpiration,
    comapanyCommand,
    setComapanyCommand,
    addMaterials,
    setAddMaterials,
  } = props;

  const [isFormFilled, setIsFormFilled] = useState(false);
  const [formErrors, setFormErrors] = useState(null);

  const submitHandler = (event) => {
    event.preventDefault();
    let data;
    let url;

    if (participationType === "1") {
      url = `/individual/`;

      let ip = haveIp === "1" ? true : false;

      data = {
        city: city,
        place: place,
        have_ip: ip,
        inn: inn,
        specialization: specialization,
        expiration: expiration,
        portfolio: portfolio,
        format: format,
        command: command,
      };
    }

    if (participationType === "2") {
      url = `/command/`;

      data = {
        position: position,
        company_name: companyName,
        legal_name: legalName,
        special: special.value,
        other_special: otherSpecial,
        ogrn: ogrn,
        site: site,
        expiration: companyExpiration,
        command: comapanyCommand,
        add_materials: addMaterials,
      };
    }

    client
      .post(url, data)
      .then((res) => {
        setStep(4);
      })
      .catch((error) => {
        if (error.response?.status === 400) {
          setFormErrors(error.response.data);
        }
      });
  };

  useEffect(() => {
    if (participationType === "1") {
      setIsFormFilled(
        city &&
          place &&
          haveIp &&
          specialization &&
          expiration &&
          portfolio &&
          format
      );
    }

    if (participationType === "2") {
      setIsFormFilled(
        position &&
          companyName &&
          legalName &&
          special &&
          ogrn &&
          site &&
          companyExpiration &&
          comapanyCommand
      );
    }
  }, [
    city,
    place,
    haveIp,
    specialization,
    expiration,
    portfolio,
    format,
    position,
    companyName,
    legalName,
    special,
    ogrn,
    site,
    companyExpiration,
    comapanyCommand,
    participationType,
  ]);

  useEffect(() => {
    if (formErrors) {
      const firstError = Object.keys(formErrors)[0];
      const firstErrorInput = document.querySelector(`[name=${firstError}]`);

      firstErrorInput.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "start",
      });
    }
  }, [formErrors]);

  return (
    <form action="." onSubmit={submitHandler}>
      {participationType === "1" && (
        <div className="mm-form__inner">
          <InputText
            title="Город проживания *"
            placeholder="Москва"
            value={city}
            onChange={setCity}
            error={formErrors?.city}
            name="city"
          />
          <InputText
            title="Место работы или учебы *"
            placeholder="Название учреждения"
            value={place}
            onChange={setPlace}
            error={formErrors?.place}
            name="place"
          />
          <InputRadio
            title="Есть ли у вас ИП или статус самозанятого? *"
            choices={STATUS_CHOICES}
            onChange={setHaveIp}
            value={haveIp}
            isGorizontal
            error={formErrors?.have_ip}
            name="have_ip"
          />
          {haveIp === "1" && (
            <InputDate
              title="ИНН *"
              placeholder="77 77777777"
              mask="99 9999999999"
              value={inn}
              onChange={setInn}
              error={formErrors?.inn}
              name="inn"
            />
          )}
          <InputTextarea
            title="Опишите вашу специализацию *"
            placeholder="Объем текста не должен превышать 500 символов"
            maxlength={500}
            value={specialization}
            onChange={setSpecialization}
            error={formErrors?.specialization}
            name="specialization"
          />
          <InputTextarea
            title="Опишите ваш опыт *"
            placeholder="Объем текста не должен превышать 500 символов"
            maxlength={500}
            value={expiration}
            onChange={setExpiration}
            error={formErrors?.expiration}
            name="expiration"
          />
          <InputFile
            title="Портфолио *"
            subTitle="Загрузите файл (форматы .pdf и .pptx, размер файла не должен превышать 10 МБ) или ссылку на Яндекс.Диск"
            placeholder="https://disk.yandex.ru/.."
            value={portfolio}
            onChange={setPortfolio}
            error={formErrors?.portfolio}
            name="portfolio"
          />
          <InputRadio
            title="Выберите формат участия *"
            choices={FORMAT_CHOICES}
            name="format"
            onChange={setFormat}
            value={format}
            isGorizontal
            error={formErrors?.format}
            mobileColumn
          />
          {format === "command" && (
            <InputTextarea
              title="Команда, которая участвовала в разработке решения *"
              placeholder="Объем текста не должен превышать 1000 символов"
              maxlength={1000}
              value={command}
              onChange={setCommand}
              error={formErrors?.command}
              name="command"
            />
          )}
        </div>
      )}

      {participationType === "2" && (
        <div className="mm-form__inner">
          <InputText
            title="Ваша должность в организации *"
            placeholder="Должность"
            value={position}
            onChange={setPosition}
            error={formErrors?.position}
            name="position"
          />
          <InputText
            title="Название компании *"
            placeholder="Название"
            value={companyName}
            onChange={setCompanyName}
            error={formErrors?.company_name}
            name="company_name"
          />
          <InputText
            title="Юридическое наименование *"
            placeholder="ООО Название"
            value={legalName}
            onChange={setLegalName}
            error={formErrors?.legal_name}
            name="legal_name"
          />
          <InputSelect
            title="Специализация деятельности *"
            placeholder="Выберите специализацию"
            value={special}
            onChange={setSpecial}
            error={formErrors?.special}
            name="special"
            options={SPECIAL_CHOICES}
          />
          {special.value === "other" && (
            <InputText
              title="Впишите свою специализацию *"
              placeholder="Специализация"
              value={otherSpecial}
              onChange={setOtherSpecial}
              error={formErrors?.other_special}
              name="other_special"
            />
          )}
          <InputText
            title="ОГРН юридического лица *"
            placeholder="Номер ОГРН"
            value={ogrn}
            onChange={setOgrn}
            error={formErrors?.ogrn}
            name="ogrn"
          />
          <InputText
            title="Сайт компании *"
            placeholder="https://..."
            value={site}
            onChange={setSite}
            error={formErrors?.site}
            name="site"
          />
          <InputTextarea
            title="Опишите опыт вашей организации *"
            placeholder="Объем текста не должен превышать 500 символов"
            maxlength={500}
            value={companyExpiration}
            onChange={setCompanyExpiration}
            error={formErrors?.expiration}
            name="expiration"
          />
          <InputTextarea
            title="Команда, которая участвовала в разработке решения *"
            placeholder="Объем текста не должен превышать 1000 символов"
            maxlength={1000}
            value={comapanyCommand}
            onChange={setComapanyCommand}
            error={formErrors?.command}
            name="command"
          />
          <InputFile
            title="Загрузите дополнительные материалы"
            subTitle="Это может быть презентация вашей компании. Форматы .pdf и .pptx, размер файла не должен превышать 10 МБ"
            placeholder="https://disk.yandex.ru/.."
            value={addMaterials}
            onChange={setAddMaterials}
            error={formErrors?.add_materials}
            name="add_materials"
          />
        </div>
      )}

      <div className="buttons-wrapper">
        <PrewButton
          onClick={() => {
            setStep(2);
            setParticipationType(null);
          }}
        />
        <NextButton type="submit" disabled={!isFormFilled} />
      </div>
    </form>
  );
}

export default Step3;
